/* @flow */
// Even rotation for audio items (jingles, motivational quotes, the gym's ads):
// every item in the pool plays once, in a shuffled order, before any repeats,
// and the same item never plays twice in a row across rounds. The pool is
// fetched afresh at the start of each round, so newly added or switched-off
// items are picked up.

const keyOf = (item: any) => (item && (item.uuid || item.url)) || ''

export class Rotation {
  fetchPool: () => Promise<any[]>
  bag: any[] = []
  last = ''

  constructor (fetchPool: () => Promise<any[]>) {
    this.fetchPool = fetchPool
  }

  async next (): Promise<any> {
    if (this.bag.length === 0) {
      let pool = []
      try {
        pool = (await this.fetchPool()) || []
      } catch (e) {
        pool = []
      }
      // one of each (the server may return the same item more than once)
      const seen = {}
      pool = pool.filter((item) => {
        const k = keyOf(item)
        if (!k || seen[k]) return false
        seen[k] = true
        return true
      })
      this.bag = pool
        .map((item) => [Math.random(), item])
        .sort((a, b) => a[0] - b[0])
        .map((pair) => pair[1])
      if (this.bag.length > 1 && keyOf(this.bag[0]) === this.last) {
        this.bag.push(this.bag.shift())
      }
    }
    const item = this.bag.shift()
    if (item) this.last = keyOf(item)
    return item
  }

  // Hand an item back so it's the next one out (used when peeking at a pool)
  putBack (item: any) {
    if (item) this.bag.unshift(item)
  }

  reset () {
    this.bag = []
  }
}
